import { EventEmitter, Component, ChangeDetectionStrategy, ViewEncapsulation, ElementRef, Renderer2, ChangeDetectorRef, Input, Output, NgModule } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { breakpointBelow, ResponsiveService, B2CSharedResponsiveModule } from 'b2c-ui/core';
import { tap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { I18nModule } from 'b2c-ui/i18n';
import { B2CNgzIconModule } from 'b2c-ui/ngz-icons';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-articles.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * ##### Import this component individually to your module
 * `import { B2CArticlesModule } from 'b2c-ui/articles';`
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'b2c-ui/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from 'ng-zorro-antd/grid';
import * as ɵngcc4 from 'ng-zorro-antd/icon';
import * as ɵngcc5 from 'ng-zorro-antd/tooltip';
import * as ɵngcc6 from 'b2c-ui/i18n';

function B2CArticlesComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CArticlesComponent_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c0 = function (a0, a1) { return { "b2c-article-high-light": a0, "isMobile": a1 }; };
function B2CArticlesComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtemplate(1, B2CArticlesComponent_div_0_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(2, B2CArticlesComponent_div_0_ng_container_2_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    const _r4 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c0, ctx_r0.highLight, ctx_r0.isMobile));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4);
} }
function B2CArticlesComponent_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CArticlesComponent_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c1 = function (a0) { return { "isMobile": a0 }; };
function B2CArticlesComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵtemplate(2, B2CArticlesComponent_div_1_ng_container_2_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 8);
    ɵngcc0.ɵɵtemplate(4, B2CArticlesComponent_div_1_ng_container_4_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(5);
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("nzGutter", ctx_r1.isMobile ? 10 : 30)("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c1, ctx_r1.isMobile));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function B2CArticlesComponent_ng_template_2_div_0_img_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "img", 16);
    ɵngcc0.ɵɵlistener("click", function B2CArticlesComponent_ng_template_2_div_0_img_2_Template_img_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(3); return ctx_r13.onImageClick(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("src", ctx_r12.image, ɵngcc0.ɵɵsanitizeUrl)("alt", ctx_r12.title);
} }
function B2CArticlesComponent_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵtemplate(2, B2CArticlesComponent_ng_template_2_div_0_img_2_Template, 1, 2, "img", 13);
    ɵngcc0.ɵɵelementStart(3, "div", 14);
    ɵngcc0.ɵɵelement(4, "i", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.image);
} }
function B2CArticlesComponent_ng_template_2_div_1_img_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "img", 16);
    ɵngcc0.ɵɵlistener("click", function B2CArticlesComponent_ng_template_2_div_1_img_1_Template_img_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(3); return ctx_r16.onImageClick(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("src", ctx_r15.image, ɵngcc0.ɵɵsanitizeUrl)("alt", ctx_r15.title);
} }
function B2CArticlesComponent_ng_template_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵtemplate(1, B2CArticlesComponent_ng_template_2_div_1_img_1_Template, 1, 2, "img", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.image);
} }
function B2CArticlesComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, B2CArticlesComponent_ng_template_2_div_0_Template, 5, 1, "div", 9);
    ɵngcc0.ɵɵtemplate(1, B2CArticlesComponent_ng_template_2_div_1_Template, 2, 1, "div", 10);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.webcast);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.webcast);
} }
function B2CArticlesComponent_ng_template_4_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "span", 33);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r18.category);
} }
function B2CArticlesComponent_ng_template_4_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵelementStart(2, "div", 34);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 35);
    ɵngcc0.ɵɵelement(5, "img", 36);
    ɵngcc0.ɵɵelementStart(6, "a", 37);
    ɵngcc0.ɵɵtext(7, " BM ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(8, "|");
    ɵngcc0.ɵɵelementStart(9, "a", 38);
    ɵngcc0.ɵɵtext(10, " \u534E\u8BED ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r28.category);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate1("href", "https://translate.google.com/translate?depth=1&nv=1&pto=aue,boq&rurl=translate.google.com&sl=auto&sp=nmt4&tl=ms&u=https://www.fsmone.com.my/funds/research/article-details/", ctx_r28.articleNo, "", ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate1("href", "https://translate.google.com/translate?hl=&sl=auto&tl=zh-CN&u=https://www.fsmone.com.my/funds/research/article-details/", ctx_r28.articleNo, "", ɵngcc0.ɵɵsanitizeUrl);
} }
function B2CArticlesComponent_ng_template_4_div_3_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵelementStart(2, "div", 34);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 39);
    ɵngcc0.ɵɵelement(5, "img", 36);
    ɵngcc0.ɵɵelementStart(6, "a", 37);
    ɵngcc0.ɵɵtext(7, " BM ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(8, "|");
    ɵngcc0.ɵɵelementStart(9, "a", 38);
    ɵngcc0.ɵɵtext(10, " \u534E\u8BED ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r30.category);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate1("href", "https://translate.google.com/translate?depth=1&nv=1&pto=aue,boq&rurl=translate.google.com&sl=auto&sp=nmt4&tl=ms&u=https://www.fsmone.com.my/funds/research/article-details/", ctx_r30.articleNo, "", ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate1("href", "https://translate.google.com/translate?hl=&sl=auto&tl=zh-CN&u=https://www.fsmone.com.my/funds/research/article-details/", ctx_r30.articleNo, "", ɵngcc0.ɵɵsanitizeUrl);
} }
function B2CArticlesComponent_ng_template_4_div_3_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵelementStart(2, "div", 40);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 41);
    ɵngcc0.ɵɵelement(5, "img", 36);
    ɵngcc0.ɵɵelementStart(6, "a", 37);
    ɵngcc0.ɵɵtext(7, " BM ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(8, "|");
    ɵngcc0.ɵɵelementStart(9, "a", 38);
    ɵngcc0.ɵɵtext(10, " \u534E\u8BED ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r31.category);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate1("href", "https://translate.google.com/translate?depth=1&nv=1&pto=aue,boq&rurl=translate.google.com&sl=auto&sp=nmt4&tl=ms&u=https://www.fsmone.com.my/funds/research/article-details/", ctx_r31.articleNo, "", ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate1("href", "https://translate.google.com/translate?hl=&sl=auto&tl=zh-CN&u=https://www.fsmone.com.my/funds/research/article-details/", ctx_r31.articleNo, "", ɵngcc0.ɵɵsanitizeUrl);
} }
function B2CArticlesComponent_ng_template_4_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, B2CArticlesComponent_ng_template_4_div_3_div_2_div_1_Template, 11, 3, "div", 19);
    ɵngcc0.ɵɵtemplate(2, B2CArticlesComponent_ng_template_4_div_3_div_2_div_2_Template, 11, 3, "div", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r29.isMobile || ctx_r29.category.length < 26);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r29.isMobile && ctx_r29.category.length > 25);
} }
function B2CArticlesComponent_ng_template_4_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, B2CArticlesComponent_ng_template_4_div_3_div_1_Template, 11, 3, "div", 19);
    ɵngcc0.ɵɵtemplate(2, B2CArticlesComponent_ng_template_4_div_3_div_2_Template, 3, 2, "div", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r19.specialHandling && ctx_r19.specialHandling == "special");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r19.specialHandling || ctx_r19.specialHandling != "special");
} }
function B2CArticlesComponent_ng_template_4_a_5_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 42);
    ɵngcc0.ɵɵlistener("click", function B2CArticlesComponent_ng_template_4_a_5_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r32 = ɵngcc0.ɵɵnextContext(2); return ctx_r32.onTitleClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "slice");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r20.title.length > 80 ? ɵngcc0.ɵɵpipeBind3(2, 1, ctx_r20.title, 0, 80) + ".." : ctx_r20.title, " ");
} }
function B2CArticlesComponent_ng_template_4_a_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 43);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "slice");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r21.articleURL, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵproperty("target", "_blank");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r21.title.length > 80 ? ɵngcc0.ɵɵpipeBind3(2, 3, ctx_r21.title, 0, 80) + ".." : ctx_r21.title, " ");
} }
function B2CArticlesComponent_ng_template_4_p_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 44);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r22.description);
} }
function B2CArticlesComponent_ng_template_4_a_12_Template(rf, ctx) { if (rf & 1) {
    const _r35 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 45);
    ɵngcc0.ɵɵlistener("click", function B2CArticlesComponent_ng_template_4_a_12_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r35); const ctx_r34 = ɵngcc0.ɵɵnextContext(2); return ctx_r34.onAuthorClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r23.author);
} }
function B2CArticlesComponent_ng_template_4_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r25 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r25.author);
} }
function B2CArticlesComponent_ng_template_4_span_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelementStart(1, "span", 46);
    ɵngcc0.ɵɵtext(2, "\u2022");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r26.duration, " ", ctx_r26.durationUnit, " read");
} }
function B2CArticlesComponent_ng_template_4_div_26_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 47);
    ɵngcc0.ɵɵelementStart(1, "a", 48);
    ɵngcc0.ɵɵlistener("click", function B2CArticlesComponent_ng_template_4_div_26_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r37); const ctx_r36 = ɵngcc0.ɵɵnextContext(2); return ctx_r36.onShare(); });
    ɵngcc0.ɵɵelement(2, "i", 49);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
const _c2 = function (a0) { return { "pt-2": a0 }; };
const _c3 = function (a0, a1) { return { "b2c-article-title-cover-default": a0, "b2c-article-title-cover-highLight": a1 }; };
function B2CArticlesComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "div", 18);
    ɵngcc0.ɵɵtemplate(2, B2CArticlesComponent_ng_template_4_div_2_Template, 3, 1, "div", 19);
    ɵngcc0.ɵɵtemplate(3, B2CArticlesComponent_ng_template_4_div_3_Template, 3, 2, "div", 19);
    ɵngcc0.ɵɵelementStart(4, "div", 18);
    ɵngcc0.ɵɵtemplate(5, B2CArticlesComponent_ng_template_4_a_5_Template, 3, 5, "a", 20);
    ɵngcc0.ɵɵtemplate(6, B2CArticlesComponent_ng_template_4_a_6_Template, 3, 7, "a", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, B2CArticlesComponent_ng_template_4_p_7_Template, 2, 1, "p", 22);
    ɵngcc0.ɵɵelementStart(8, "div", 23);
    ɵngcc0.ɵɵelementStart(9, "div");
    ɵngcc0.ɵɵelementStart(10, "span", 24);
    ɵngcc0.ɵɵtext(11, "By ");
    ɵngcc0.ɵɵtemplate(12, B2CArticlesComponent_ng_template_4_a_12_Template, 2, 1, "a", 25);
    ɵngcc0.ɵɵtemplate(13, B2CArticlesComponent_ng_template_4_ng_template_13_Template, 1, 1, "ng-template", null, 26, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "span", 27);
    ɵngcc0.ɵɵelement(16, "i", 28);
    ɵngcc0.ɵɵelementStart(17, "span", 29);
    ɵngcc0.ɵɵtext(18);
    ɵngcc0.ɵɵpipe(19, "sdate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(20, B2CArticlesComponent_ng_template_4_span_20_Template, 5, 2, "span", 19);
    ɵngcc0.ɵɵelementStart(21, "span", 30);
    ɵngcc0.ɵɵelement(22, "i", 31);
    ɵngcc0.ɵɵelementStart(23, "span");
    ɵngcc0.ɵɵtext(24);
    ɵngcc0.ɵɵpipe(25, "number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(26, B2CArticlesComponent_ng_template_4_div_26_Template, 3, 0, "div", 32);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r24 = ɵngcc0.ɵɵreference(14);
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(19, _c2, !ctx_r5.isMobile));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r5.category || ctx_r5.category == "FSM Buzz" || ctx_r5.category == "Fund House Depository" || ctx_r5.category == "Managed Portfolio");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.category && ctx_r5.category != "FSM Buzz" && ctx_r5.category != "Fund House Depository" && ctx_r5.category != "Managed Portfolio");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(21, _c3, !ctx_r5.highLight, ctx_r5.highLight));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.articleURL == null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.articleURL != null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.highLight && !ctx_r5.isMobile);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.authorClickable)("ngIfElse", _r24);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(19, 14, ctx_r5.date));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.duration);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate2("", ɵngcc0.ɵɵpipeBind2(25, 16, ctx_r5.view, "1.0-0"), " ", ctx_r5.view > 1 ? "views" : "view", "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.shareAble);
} }
class B2CArticlesComponent {
    /**
     * @ignore
     * @param {?} elementRef
     * @param {?} renderer
     * @param {?} cdRef
     * @param {?} responsiveService
     */
    constructor(elementRef, renderer, cdRef, responsiveService) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.cdRef = cdRef;
        this.responsiveService = responsiveService;
        this._horizontal = false;
        this._highLight = false;
        this._authorClickable = false;
        this._shareAble = false;
        this._view = 0;
        this._webcast = false;
        this.durationUnit = 'min';
        this.isMobile = false;
        this.showView = false;
        /**
         * Share on change
         */
        this.share = new EventEmitter();
        /**
         * Author on click
         */
        this.authorClick = new EventEmitter();
        /**
         * Article on click
         */
        this.articleClick = new EventEmitter();
        this.renderer.addClass(elementRef.nativeElement, 'b2c-articles');
        this.responsiveService
            .observeBoolean(breakpointBelow.sm)
            .pipe(tap((/**
         * @param {?} matched
         * @return {?}
         */
        (matched) => {
            this.isMobile = matched;
            this.cdRef.markForCheck();
        })))
            .subscribe();
    }
    /**
     * Set visibility of share icon. default true
     * @param {?} value
     * @return {?}
     */
    set shareAble(value) {
        this._shareAble = coerceBooleanProperty(value);
    }
    /**
     * @return {?}
     */
    get shareAble() {
        return this._shareAble;
    }
    /**
     * Set Author name as Hyperlink. default false
     * @param {?} value
     * @return {?}
     */
    set authorClickable(value) {
        this._authorClickable = coerceBooleanProperty(value);
    }
    /**
     * @return {?}
     */
    get authorClickable() {
        return this._authorClickable;
    }
    /**
     * Set articles to horizontal
     * @param {?} value
     * @return {?}
     */
    set horizontal(value) {
        this._horizontal = coerceBooleanProperty(value);
    }
    /**
     * @return {?}
     */
    get horizontal() {
        return this._horizontal;
    }
    /**
     * Set articles highLight
     * @param {?} value
     * @return {?}
     */
    set highLight(value) {
        this._highLight = coerceBooleanProperty(value);
    }
    /**
     * @return {?}
     */
    get highLight() {
        return this._highLight;
    }
    /**
     * Set articles category
     * @param {?} value
     * @return {?}
     */
    set date(value) {
        this.nativeDate = this.checkDateType(value);
    }
    /**
     * @return {?}
     */
    get date() {
        return this.nativeDate;
    }
    /**
     * Set articles read duration
     * @param {?} value
     * @return {?}
     */
    set readDuration(value) {
        this.duration = value;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set view(value) {
        this._view = value;
        this.showView = this._view >= 0 && this._view !== null;
    }
    /**
     * @return {?}
     */
    get view() {
        return this._view;
    }
    /**
     * Set articles webcast
     * @param {?} value
     * @return {?}
     */
    set webcast(value) {
        this._webcast = coerceBooleanProperty(value);
    }
    /**
     * @return {?}
     */
    get webcast() {
        return this._webcast;
    }
    /**
     * @ignore
     * @return {?}
     */
    onShare() {
        this.share.emit();
    }
    /**
     * @ignore
     * @return {?}
     */
    onAuthorClick() {
        this.authorClick.emit();
    }
    /**
     * @ignore
     * @return {?}
     */
    onImageClick() {
        this.articleClick.emit();
    }
    /**
     * @ignore
     * @return {?}
     */
    onTitleClick() {
        this.articleClick.emit();
    }
    /**
     * @ignore
     * @private
     * @param {?} value
     * @return {?}
     */
    checkDateType(value) {
        if (typeof value === 'string' || typeof value === 'number') {
            return new Date(value);
        }
        else {
            return value;
        }
    }
}
B2CArticlesComponent.ɵfac = function B2CArticlesComponent_Factory(t) { return new (t || B2CArticlesComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ResponsiveService)); };
B2CArticlesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CArticlesComponent, selectors: [["b2c-articles"]], inputs: { shareAble: "shareAble", authorClickable: "authorClickable", horizontal: "horizontal", highLight: "highLight", date: "date", readDuration: "readDuration", view: "view", webcast: "webcast", articleURL: "articleURL", title: "title", author: "author", category: "category", description: "description", image: "image", articleNo: "articleNo", specialHandling: "specialHandling" }, outputs: { share: "share", authorClick: "authorClick", articleClick: "articleClick" }, exportAs: ["b2cArticles"], decls: 6, vars: 2, consts: [["class", "b2c-article-grid", 3, "ngClass", 4, "ngIf"], ["nz-row", "", "class", "b2c-article-list", 3, "nzGutter", "ngClass", 4, "ngIf"], ["articleImg", ""], ["articlesContent", ""], [1, "b2c-article-grid", 3, "ngClass"], [4, "ngTemplateOutlet"], ["nz-row", "", 1, "b2c-article-list", 3, "nzGutter", "ngClass"], ["nz-col", "", "nzSpan", "15", 1, "align-self-stretch", "d-flex", "flex-column", "justify-content-between"], ["nz-col", "", "nzSpan", "9"], ["class", "webcast-thumb", 4, "ngIf"], ["class", "webcast-img", 4, "ngIf"], [1, "webcast-thumb"], [1, "webcast-img"], ["class", "img-fluid pointer rounded", 3, "src", "alt", "click", 4, "ngIf"], [1, "webcast-overlay", "text-center", "rounded"], ["nz-icon", "", "nzType", "play-circle", "nzTheme", "fill", 1, "webcast-play-icon"], [1, "img-fluid", "pointer", "rounded", 3, "src", "alt", "click"], [1, "b2c-article-content"], [3, "ngClass"], [4, "ngIf"], ["class", "b2c-article-title", 3, "click", 4, "ngIf"], ["class", "b2c-article-title", 3, "href", "target", 4, "ngIf"], ["class", "b2c-article-description", 4, "ngIf"], [1, "b2b-article-meta"], [1, "b2c-article-author"], ["class", "author-link", 3, "click", 4, "ngIf", "ngIfElse"], ["normalAuthor", ""], [1, "text-black-7", "font-weight-normal"], ["nz-icon", "", "nzType", "calendar", "nzTheme", "outline"], [1, "pl-1", "b2c-article-date"], [1, "ml-1"], ["nz-icon", "", "nzType", "eye", "nzTheme", "outline", 1, "mx-1"], ["class", "b2c-article-action", 4, "ngIf"], [1, "b2c-article-category"], [1, "b2c-article-category", 2, "display", "inline"], [2, "display", "inline"], ["alt", "snap", "src", "assets/images/articles/google-translate.svg", 2, "width", "auto", "height", "auto"], ["target", "_blank", 1, "text-xs", 2, "font-weight", "bold", 3, "href"], ["target", "_blank", 1, "m1-1", "text-xs", 2, "font-weight", "bold", 3, "href"], [2, "float", "right", "display", "inline"], [1, "b2c-article-category", 2, "display", "inline-block"], [2, "display", "inline-block"], [1, "b2c-article-title", 3, "click"], [1, "b2c-article-title", 3, "href", "target"], [1, "b2c-article-description"], [1, "author-link", 3, "click"], [1, "mx-1"], [1, "b2c-article-action"], ["nz-tooltip", "", "nzTooltipTitle", "Share", 1, "share-icon", "text-black-7", "mr-3", 3, "click"], ["nz-icon", "", "nzType", "share-alt", "nzTheme", "outline"]], template: function B2CArticlesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, B2CArticlesComponent_div_0_Template, 3, 6, "div", 0);
        ɵngcc0.ɵɵtemplate(1, B2CArticlesComponent_div_1_Template, 5, 6, "div", 1);
        ɵngcc0.ɵɵtemplate(2, B2CArticlesComponent_ng_template_2_Template, 2, 2, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(4, B2CArticlesComponent_ng_template_4_Template, 27, 24, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.horizontal);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.horizontal);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgClass, ɵngcc2.NgTemplateOutlet, ɵngcc3.NzRowDirective, ɵngcc3.NzColDirective, ɵngcc4.NzIconDirective, ɵngcc5.NzTooltipDirective], pipes: [ɵngcc6.StandardDatePipe, ɵngcc2.DecimalPipe, ɵngcc2.SlicePipe], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
B2CArticlesComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: ChangeDetectorRef },
    { type: ResponsiveService }
];
B2CArticlesComponent.propDecorators = {
    shareAble: [{ type: Input }],
    authorClickable: [{ type: Input }],
    horizontal: [{ type: Input }],
    articleURL: [{ type: Input }],
    title: [{ type: Input }],
    author: [{ type: Input }],
    category: [{ type: Input }],
    highLight: [{ type: Input }],
    description: [{ type: Input }],
    date: [{ type: Input }],
    image: [{ type: Input }],
    readDuration: [{ type: Input }],
    view: [{ type: Input }],
    webcast: [{ type: Input }],
    share: [{ type: Output }],
    authorClick: [{ type: Output }],
    articleClick: [{ type: Output }],
    articleNo: [{ type: Input }],
    specialHandling: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CArticlesComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-articles',
                exportAs: 'b2cArticles',
                template: "<div class=\"b2c-article-grid\" [ngClass]=\"{'b2c-article-high-light': highLight, 'isMobile': isMobile}\"\r\n     *ngIf=\"!horizontal\">\r\n  <ng-container *ngTemplateOutlet=\"articleImg\"></ng-container>\r\n  <ng-container *ngTemplateOutlet=\"articlesContent\"></ng-container>\r\n</div>\r\n\r\n<div nz-row [nzGutter]=\"isMobile ? 10 : 30\" class=\"b2c-article-list\" [ngClass]=\"{'isMobile': isMobile}\"\r\n     *ngIf=\"horizontal\">\r\n  <div nz-col nzSpan=\"15\" class=\"align-self-stretch d-flex flex-column justify-content-between\">\r\n    <ng-container *ngTemplateOutlet=\"articlesContent\"></ng-container>\r\n  </div>\r\n  <div nz-col nzSpan=\"9\">\r\n    <ng-container *ngTemplateOutlet=\"articleImg\"></ng-container>\r\n  </div>\r\n</div>\r\n\r\n<ng-template #articleImg>\r\n  <div *ngIf=\"webcast\" class=\"webcast-thumb\">\r\n    <div class=\"webcast-img\">\r\n      <img *ngIf=\"image\" (click)=\"onImageClick()\" class=\"img-fluid pointer rounded\" [src]=\"image\" [alt]=\"title\"/>\r\n      <div class=\"webcast-overlay text-center rounded\">\r\n        <i nz-icon nzType=\"play-circle\" nzTheme=\"fill\" class=\"webcast-play-icon\"></i>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div *ngIf=\"!webcast\" class=\"webcast-img\">\r\n    <img *ngIf=\"image\" (click)=\"onImageClick()\" class=\"img-fluid pointer rounded\" [src]=\"image\" [alt]=\"title\"/>\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #articlesContent>\r\n  <div class=\"b2c-article-content\">\r\n    <div [ngClass]=\"{'pt-2' : !isMobile}\">\r\n\r\n\r\n      <div *ngIf=\"!category || category=='FSM Buzz' || category=='Fund House Depository' || category=='Managed Portfolio'\">\r\n        <span class=\"b2c-article-category\">{{ category }}</span>\r\n      </div>\r\n\r\n\r\n      <div *ngIf=\"category && category!='FSM Buzz' && category!='Fund House Depository' && category!='Managed Portfolio'\">\r\n        <div *ngIf=\"specialHandling && specialHandling=='special'\">\r\n          <div>\r\n            <div style=\"display:inline;\" class=\"b2c-article-category\">{{ category }}</div>\r\n            <div style=\"display:inline\"><img alt=\"snap\" style=\"width: auto; height: auto;\" src=\"assets/images/articles/google-translate.svg\"><a style=\"font-weight: bold;\" href=\"https://translate.google.com/translate?depth=1&nv=1&pto=aue,boq&rurl=translate.google.com&sl=auto&sp=nmt4&tl=ms&u=https://www.fsmone.com.my/funds/research/article-details/{{articleNo}}\" class=\"text-xs\" target=\"_blank\"> BM </a>|<a style=\"font-weight: bold;\" href=\"https://translate.google.com/translate?hl=&sl=auto&tl=zh-CN&u=https://www.fsmone.com.my/funds/research/article-details/{{articleNo}}\" class=\"m1-1 text-xs\" target=\"_blank\"> \u534E\u8BED </a></div>\r\n          </div>\r\n        </div>\r\n        <div *ngIf=\"!specialHandling || specialHandling!='special'\">\r\n          <div *ngIf=\"!isMobile || category.length<26\">\r\n            <div>\r\n              <div style=\"display:inline\" class=\"b2c-article-category\">{{ category }}</div>\r\n              <div style=\"float:right;display:inline\"><img alt=\"snap\" style=\"width: auto; height: auto;\" src=\"assets/images/articles/google-translate.svg\"><a style=\"font-weight: bold;\" href=\"https://translate.google.com/translate?depth=1&nv=1&pto=aue,boq&rurl=translate.google.com&sl=auto&sp=nmt4&tl=ms&u=https://www.fsmone.com.my/funds/research/article-details/{{articleNo}}\" class=\"text-xs\" target=\"_blank\"> BM </a>|<a style=\"font-weight: bold;\" href=\"https://translate.google.com/translate?hl=&sl=auto&tl=zh-CN&u=https://www.fsmone.com.my/funds/research/article-details/{{articleNo}}\" class=\"m1-1 text-xs\" target=\"_blank\"> \u534E\u8BED </a></div>\r\n            </div>\r\n          </div>\r\n          <div *ngIf=\"isMobile && category.length>25\">\r\n            <div>\r\n              <div style=\"display:inline-block\" class=\"b2c-article-category\">{{ category }}</div>\r\n              <div style=\"display:inline-block\"><img alt=\"snap\" style=\"width: auto; height: auto;\" src=\"assets/images/articles/google-translate.svg\"><a style=\"font-weight: bold;\" href=\"https://translate.google.com/translate?depth=1&nv=1&pto=aue,boq&rurl=translate.google.com&sl=auto&sp=nmt4&tl=ms&u=https://www.fsmone.com.my/funds/research/article-details/{{articleNo}}\" class=\"text-xs\" target=\"_blank\"> BM </a>|<a style=\"font-weight: bold;\" href=\"https://translate.google.com/translate?hl=&sl=auto&tl=zh-CN&u=https://www.fsmone.com.my/funds/research/article-details/{{articleNo}}\" class=\"m1-1 text-xs\" target=\"_blank\"> \u534E\u8BED </a></div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div [ngClass]=\"{'b2c-article-title-cover-default' : !highLight, 'b2c-article-title-cover-highLight' : highLight}\">\r\n        <a *ngIf=\"articleURL == null\" class=\"b2c-article-title\" (click)=\"onTitleClick()\">\r\n          {{ (title.length>80)? (title | slice:0:80)+'..':(title) }}\r\n        </a>\r\n        <a *ngIf=\"articleURL != null\" class=\"b2c-article-title\" href=\"{{articleURL}}\" [target]=\"'_blank'\">\r\n          {{ (title.length>80)? (title | slice:0:80)+'..':(title) }}\r\n        </a>\r\n      </div>\r\n    </div>\r\n\r\n\r\n    <p class=\"b2c-article-description\" *ngIf=\"highLight && !isMobile\">{{description}}</p>\r\n    <div class=\"b2b-article-meta\">\r\n      <div>\r\n        <span class=\"b2c-article-author\">By\r\n          <a class=\"author-link\" *ngIf=\"authorClickable;else normalAuthor\" (click)=\"onAuthorClick()\">{{ author }}</a>\r\n          <ng-template #normalAuthor>{{ author }}</ng-template>\r\n        </span>\r\n        <span class=\"text-black-7 font-weight-normal\">\r\n          <i nz-icon nzType=\"calendar\" nzTheme=\"outline\"></i>\r\n          <span class=\"pl-1 b2c-article-date\">{{ date | sdate }}</span>\r\n          <span *ngIf=\"duration\">\r\n            <span class=\"mx-1\">&bull;</span>\r\n            <span>{{ duration }} {{ durationUnit }} read</span>\r\n          </span>\r\n          <span class=\"ml-1\">\r\n          <i class=\"mx-1\" nz-icon nzType=\"eye\" nzTheme=\"outline\"></i>\r\n          <span>{{view | number : '1.0-0'}} {{view > 1 ? 'views' : 'view'}}</span>\r\n            </span>\r\n        </span>\r\n      </div>\r\n      <div class=\"b2c-article-action\" *ngIf=\"shareAble\">\r\n        <a (click)=\"onShare()\" class=\"share-icon text-black-7 mr-3\" nz-tooltip nzTooltipTitle=\"Share\">\r\n          <i nz-icon nzType=\"share-alt\" nzTheme=\"outline\"></i>\r\n        </a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc1.ResponsiveService }]; }, { share: [{
            type: Output
        }], authorClick: [{
            type: Output
        }], articleClick: [{
            type: Output
        }], shareAble: [{
            type: Input
        }], authorClickable: [{
            type: Input
        }], horizontal: [{
            type: Input
        }], highLight: [{
            type: Input
        }], date: [{
            type: Input
        }], readDuration: [{
            type: Input
        }], view: [{
            type: Input
        }], webcast: [{
            type: Input
        }], articleURL: [{
            type: Input
        }], title: [{
            type: Input
        }], author: [{
            type: Input
        }], category: [{
            type: Input
        }], description: [{
            type: Input
        }], image: [{
            type: Input
        }], articleNo: [{
            type: Input
        }], specialHandling: [{
            type: Input
        }] }); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    B2CArticlesComponent.prototype._horizontal;
    /**
     * @type {?}
     * @private
     */
    B2CArticlesComponent.prototype._highLight;
    /**
     * @type {?}
     * @private
     */
    B2CArticlesComponent.prototype._authorClickable;
    /**
     * @type {?}
     * @private
     */
    B2CArticlesComponent.prototype._shareAble;
    /**
     * @type {?}
     * @private
     */
    B2CArticlesComponent.prototype._view;
    /**
     * @type {?}
     * @private
     */
    B2CArticlesComponent.prototype._webcast;
    /** @type {?} */
    B2CArticlesComponent.prototype.duration;
    /** @type {?} */
    B2CArticlesComponent.prototype.durationUnit;
    /** @type {?} */
    B2CArticlesComponent.prototype.nativeDate;
    /** @type {?} */
    B2CArticlesComponent.prototype.isMobile;
    /** @type {?} */
    B2CArticlesComponent.prototype.showView;
    /**
     * Set articles url
     * @type {?}
     */
    B2CArticlesComponent.prototype.articleURL;
    /**
     * Set articles title
     * @type {?}
     */
    B2CArticlesComponent.prototype.title;
    /**
     * Set articles author
     * @type {?}
     */
    B2CArticlesComponent.prototype.author;
    /**
     * Set articles category
     * @type {?}
     */
    B2CArticlesComponent.prototype.category;
    /**
     * Set articles description
     * @type {?}
     */
    B2CArticlesComponent.prototype.description;
    /**
     * Set articles image
     * @type {?}
     */
    B2CArticlesComponent.prototype.image;
    /**
     * Share on change
     * @type {?}
     */
    B2CArticlesComponent.prototype.share;
    /**
     * Author on click
     * @type {?}
     */
    B2CArticlesComponent.prototype.authorClick;
    /**
     * Article on click
     * @type {?}
     */
    B2CArticlesComponent.prototype.articleClick;
    /**
     * Article no
     * @type {?}
     */
    B2CArticlesComponent.prototype.articleNo;
    /**
     * Article no
     * @type {?}
     */
    B2CArticlesComponent.prototype.specialHandling;
    /** @type {?} */
    B2CArticlesComponent.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    B2CArticlesComponent.prototype.renderer;
    /**
     * @type {?}
     * @private
     */
    B2CArticlesComponent.prototype.cdRef;
    /**
     * @type {?}
     * @private
     */
    B2CArticlesComponent.prototype.responsiveService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-articles.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CArticlesModule {
}
B2CArticlesModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CArticlesModule });
B2CArticlesModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CArticlesModule_Factory(t) { return new (t || B2CArticlesModule)(); }, imports: [[
            CommonModule,
            NzIconModule,
            NzToolTipModule,
            NzGridModule,
            I18nModule,
            B2CSharedResponsiveModule,
            B2CNgzIconModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CArticlesModule, { declarations: function () { return [B2CArticlesComponent]; }, imports: function () { return [CommonModule,
        NzIconModule,
        NzToolTipModule,
        NzGridModule,
        I18nModule,
        B2CSharedResponsiveModule,
        B2CNgzIconModule]; }, exports: function () { return [B2CArticlesComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CArticlesModule, [{
        type: NgModule,
        args: [{
                declarations: [B2CArticlesComponent],
                exports: [B2CArticlesComponent],
                imports: [
                    CommonModule,
                    NzIconModule,
                    NzToolTipModule,
                    NzGridModule,
                    I18nModule,
                    B2CSharedResponsiveModule,
                    B2CNgzIconModule
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-articles.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CArticlesComponent, B2CArticlesModule };


//# sourceMappingURL=b2c-ui-articles.js.map